import { render } from "./EditDeviceComponent.vue?vue&type=template&id=22a50202"
import script from "./EditDeviceComponent.vue?vue&type=script&lang=js"
export * from "./EditDeviceComponent.vue?vue&type=script&lang=js"

import "./EditDeviceComponent.vue?vue&type=style&index=0&id=22a50202&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__